import { Folder } from '@dc-shared-web/hooks'
import { AxiosInstance } from 'axios'

export interface DeleteFolderParams {
  folderId?: string
  folderUuid?: string
  office_uuid?: string
  name?: string
}

export const deleteFolder = async (
  apiClient: AxiosInstance,
  params: DeleteFolderParams
): Promise<Folder> => {
  const { data } = await apiClient.delete(`/api/folders/${params.folderUuid}`, {
    data: {
      office_uuid: params.office_uuid,
    },
  })

  return data
}
